import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function LiveAudioFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("live");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => {
    setEditingPost(post);
  };
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
  };

  const filters = [
    { id: "live", name: "Ao Vivo" },
    { id: "upcoming", name: "Agendados" },
    { id: "past", name: "Anteriores" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/live_audio?page=${pageNum}&limit=12`;
      if (filter) url += `&status=${filter}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching live audio:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [filter]);

  if (loading && posts.length === 0) {
    return <div className="liveaudio_feed_loading"><div className="liveaudio_loader"></div><span>Carregando salas...</span></div>;
  }

  return (
    <div className="liveaudio_feed">
      {filters.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {filters.map((filterItem) => (
              <button
                key={filterItem.id}
                className={`filter_btn ${filter === filterItem.id ? "active" : ""}`}
                onClick={() => setFilter(filterItem.id)}
              >
                {filterItem.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="liveaudio_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"/>
          </svg>
          <h3>Nenhuma sala encontrada</h3>
          <p>Seja o primeiro a criar uma sala!</p>
        </div>
      ) : (
        <div className="liveaudio_grid">
          {posts.map((post) => (
            <div key={post._id} className="liveaudio_card">
              <div className="liveaudio_card_header">
                {post.liveAudioData?.status === "live" && (
                  <span className="liveaudio_live_badge">
                    <span className="liveaudio_live_dot"></span>
                    AO VIVO
                  </span>
                )}
                {post.liveAudioData?.status === "upcoming" && (
                  <span className="liveaudio_upcoming_badge">AGENDADO</span>
                )}
                <span className="liveaudio_listeners">
                  <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                  {post.liveAudioData?.listenerCount || 0}
                </span>
              </div>

              <h3>{post.liveAudioData?.title || post.text}</h3>
              <p className="liveaudio_topic">{post.liveAudioData?.topic}</p>

              <div className="liveaudio_hosts">
                <span className="liveaudio_hosts_label">Hosts</span>
                <div className="liveaudio_hosts_avatars">
                  {(post.liveAudioData?.hosts || [{ picture: post.user.picture, name: post.user.first_name }]).slice(0, 3).map((host, i) => (
                    <img key={i} src={host.picture || post.user.picture} alt="" style={{ zIndex: 3 - i }} />
                  ))}
                </div>
              </div>

              <div className="liveaudio_speakers">
                <span className="liveaudio_speakers_label">Palestrantes</span>
                <div className="liveaudio_speakers_list">
                  {(post.liveAudioData?.speakers || []).slice(0, 4).map((speaker, i) => (
                    <div key={i} className="liveaudio_speaker">
                      <img src={speaker.picture} alt="" />
                      <span>{speaker.name}</span>
                    </div>
                  ))}
                  {(!post.liveAudioData?.speakers || post.liveAudioData.speakers.length === 0) && (
                    <div className="liveaudio_speaker">
                      <img src={post.user.picture} alt="" />
                      <span>{post.user.first_name}</span>
                    </div>
                  )}
                </div>
              </div>

              <Link to={`/profile/${post.user.username}`} className="liveaudio_creator">
                <img src={post.user.picture} alt="" />
                <span>Criado por {post.user.first_name}</span>
              </Link>

              <button className="liveaudio_join_btn">
                {post.liveAudioData?.status === "live" ? "Entrar" : "Lembrar"}
              </button>
              <div onClick={(e) => e.stopPropagation()}>
                <FeedPostMenu
                  post={post}
                  onEdit={handleEditPost}
                  onPostDeleted={handlePostDeleted}
                />
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="liveaudio_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais salas"}
          </button>
        </div>
      )}
      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}
    </div>
  );
}
